import React from 'react';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import { NextSeo, SocialProfileJsonLd } from 'next-seo';
import ArtistContainer from '../../components/Artist/index';
import Head from 'next/head';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore.js';

function ArtistPage(props) {
  const { artistId } = props;

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href={`https://musicart.io/artist/${artistId}`} />
      </Head>
      {props.artistData && (
        <>
          <NextSeo
            title={`${props.artistData.name} - Artist - MusicArt`}
            description={props.artistData.bio}
            openGraph={{
              type: 'website',
              title: `${props.artistData.name} - Artist - MusicArt`,
              description: props.artistData.bio,
              images: [
                {
                  url:
                    props.artistData && props.artistData.photoUrl
                      ? props.artistData.photoUrl + '_250x250?alt=media'
                      : 'https://i.imgur.com/Q0kiEsg.jpg',
                },
              ],
              site_name: 'MusicArt',
            }}
            twitter={{
              cardType: 'summary_large_image',
            }}
          />

          <SocialProfileJsonLd
            type="Person"
            name={props.artistData.name}
            url={`https://musicart.io/artist/${artistId}`}
            sameAs={[
              `${props.artistData.apple}`,
              `${props.artistData.facebook}`,
              `${props.artistData.instagram}`,
              `${props.artistData.spotify}`,
              `${props.artistData.tiktok}`,
              `${props.artistData.twitter}`,
            ]}
          />
        </>
      )}
      <Navbar transparent />
      <ArtistContainer artistData={props.artistData} />
      <Footer />
      <FooterSM />
    </>
  );
}

export async function getServerSideProps(context) {
  const { artistId } = context.params;
  let summary = await getDoc(
    doc(firebaseFireStore, 'musicartArtists', artistId),
  );

  let data = {
    ...summary.data(),
  };

  return {
    props: {
      artistData: JSON.parse(JSON.stringify(data)),
      artistId: artistId,
    },
  };
}

export default ArtistPage;
